import { render, staticRenderFns } from "./EditEducation.vue?vue&type=template&id=d0d6b178&scoped=true"
import script from "./EditEducation.vue?vue&type=script&lang=js"
export * from "./EditEducation.vue?vue&type=script&lang=js"
import style0 from "./EditEducation.vue?vue&type=style&index=0&id=d0d6b178&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d6b178",
  null
  
)

export default component.exports